import * as React from "react";

import { DrawerView } from "../../Common";

import { DrawerFragment_GiftcardHelp_Content } from "./drawer-content-giftcard-help";
import { DrawerFragment_GiftcardHelp_ViewModel } from "./drawer-fragment-giftcard-help-view-model";

export const DrawerFragment_GiftcardHelp: React.FunctionComponent = () => {
  return (
    <React.Fragment>
      <DrawerView useDrawerViewModel={DrawerFragment_GiftcardHelp_ViewModel}>
        <DrawerFragment_GiftcardHelp_Content />
      </DrawerView>
    </React.Fragment>
  );
};
